import { render, staticRenderFns } from "./PriceBox.vue?vue&type=template&id=05cc206e&scoped=true"
import script from "./PriceBox.vue?vue&type=script&lang=ts"
export * from "./PriceBox.vue?vue&type=script&lang=ts"
import style0 from "./PriceBox.vue?vue&type=style&index=0&id=05cc206e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cc206e",
  null
  
)

export default component.exports